import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./filter.css";
import Thousand from "./filters/Thousand";
import Thousandone from "./filters/Thousandone";
import Thousandtwo from "./filters/Thousandtwo";
import Thousandthree from "./filters/Thousandthree";
import Thousandfour from "./filters/Thousandfour";
import Thousandfive from "./filters/Thousandfive";
import { IoFilter } from "react-icons/io5";

const Filters = (props) => {
	const [filterData, setFilterData] = useState(null);
	const [filtername, setFiltername] = useState("");
	const [defaultValue, setDefaultValue] = useState([]);
	const [UpdateddefaultValue, setUpdateddefaultValue] = useState([]);
	const [lastChange, setLastChange] = useState(null);
	const [searchTerm, setSearchitem] = useState("");
	const [duewithindays, setDueWithinDays] = useState(0);

	const checkfiltervalues = (filtercountlist) => {
		let filtercountdata = 0;
		const deffilter = filtercountlist[0].def;

		for (let key in deffilter) {
			const current = deffilter[key];
			if (key === "Due Date" && current === "Any") continue;
			if (Array.isArray(current) && current.length > 0) {
				filtercountdata++;
			} else if (typeof current === "string" && current.trim() !== "") {
				filtercountdata++;
			} else if (typeof current === "number" && current !== 0) {
				filtercountdata++;
			}
		}

		return {
			isDefault: filtercountdata === 0,
			count: filtercountdata,
		};
	};

	useEffect(() => {
		const obj = { values: {}, def: {}, oldValues: {} };
		console.log(props.filters, "hvgfbhjfkl;bvnkl");
		if (props.filters !== undefined && props.filters !== null) {
			props.filters.forEach((filter) => {
				obj.values[filter.filtername] = filter.values;
				obj.def[filter.filtername] = filter.defval;
				obj.oldValues[filter.filtername] = filter.defval;
			});
			setDefaultValue([obj]);
			setUpdateddefaultValue([obj]);
		}
		if (props.filters !== null) {
			setFilterData(props.filters[0]);
			setFiltername(props.filters[0].filtername);
		}
	}, [props.filters]);

	const clearFilters = (e) => {
		e.preventDefault();
		defaultValue[0].def = { ...defaultValue[0].oldValues };
		props.clearFilters(-1);
	};

	const updateDefaultValues = (data) => {
		const defaultdata = JSON.parse(JSON.stringify(UpdateddefaultValue));
		defaultdata[0].def[filtername] = data;
		setUpdateddefaultValue(defaultdata);
	};

	const updateDefaultCheckboxValues = (data, lastchange) => {
		setLastChange(lastchange);
		const defaultdata = JSON.parse(JSON.stringify(UpdateddefaultValue));
		defaultdata[0].def[filtername] = data;
		console.log(data, "data");
		setUpdateddefaultValue(defaultdata);
	};

	const updateDuedaateDefaultvalues = (data, dueWithinDays) => {
		console.log(data, dueWithinDays, "data, dueWithinDays");
		const defaultdata = JSON.parse(JSON.stringify(UpdateddefaultValue));
		defaultdata[0].def[filtername] = data;
		setUpdateddefaultValue(defaultdata);
		setDueWithinDays(dueWithinDays);
	};

	const applyFilters = async (e) => {
		e.preventDefault();

		if (Object.keys(UpdateddefaultValue[0].def).length !== 0) {
			setDefaultValue(UpdateddefaultValue);

			const { isDefault, count } = await checkfiltervalues(UpdateddefaultValue);
			console.log(isDefault, count, "tyjsuykjsh");

			setTimeout(() => {
				const filterStr = Object.keys(UpdateddefaultValue[0].def)
					.map((key) => UpdateddefaultValue[0].def[key])
					.join("$#12$$");

				props.applyFilters(
					filterStr,
					UpdateddefaultValue,
					count,
					duewithindays,
				);
			}, 200);
		}
	};

	const setsearchblankhandle = () => {
		setSearchitem("");
	};

	return (
		<>
			{props.filters !== undefined && props.filters !== null && (
				<Modal
					size="lg"
					centered
					style={{ backdropFilter: "blur(4px)", backgroundColor: "#00000022" }}
					show={props.show}
					onHide={props.hide}
					backdrop={false}
				>
					<Modal.Header
						closeButton
						style={{
							paddingBottom: "8px",
							paddingTop: "8px",
							backgroundColor: "#29b6f6",
							color: "white",
						}}
					>
						<h4 style={{ marginBottom: "0px" }}>
							<IoFilter color="white" style={{ marginBottom: "5px" }} />
							&nbsp; Filters
						</h4>
						<style>{`
    .btn-close {
      filter: invert(1);
    }
  `}</style>
					</Modal.Header>

					<Modal.Body
						style={{
							paddingBottom: "0px",
							paddingTop: "0px",
							display: "flex",
							flexDirection: "column",
						}}
					>
						<div
							className="row"
							style={{ marginBottom: "0px", position: "relative", flexGrow: 1 }}
						>
							<div
								className="col-4"
								style={{
									backgroundColor: "#eceff1",
									marginLeft: "-4px",
								}}
							>
								<div className="row filternames" style={{ padding: "0px" }}>
									{props.filters.map((data, index) => {
										const defVal =
											UpdateddefaultValue?.[0]?.def?.[data.filtername];
										console.log(defVal, "defval");
										let count = 0;
										if (defVal != -1 && Array.isArray(defVal)) {
											count = defVal.length;
										} else if (
											defVal != -1 &&
											typeof defVal === "string" &&
											defVal.trim() !== ""
										) {
											count = defVal
												.split(",")
												.filter(
													(v) => v.trim() !== "" && v.trim() != -1,
												).length;
										}

										const hideCount =
											data.filtername == "Due Date" &&
											(defVal === "Any" || defVal?.trim() === "Any");

										return (
											<div
												key={index}
												className={
													"col-12 d-flex justify-content-between align-items-center" +
													(data.filtername === filtername
														? " activeee"
														: " non-active")
												}
												onClick={() => {
													setFilterData(data);
													setFiltername(data.filtername);
													setSearchitem("");
												}}
											>
												<span>{data.filtername}</span>
												{!hideCount && count > 0 && (
													<span style={{ fontSize: "14px", color: "#29b6f6" }}>
														{count}
													</span>
												)}
											</div>
										);
									})}
								</div>
							</div>
							<div
								className="col-8"
								style={{
									maxHeight: "400px",
									overflow: "hidden",
									padding: "12px 10px",
								}}
							>
								<div>
									{filterData &&
										(filterData.filtertype == 1005 ? (
											<Thousandfive
												filterData={
													UpdateddefaultValue[0].values[filterData.filtername]
												}
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												duewithindays={duewithindays || 0}
												onChange={(val, duewithindays) =>
													updateDuedaateDefaultvalues(val, duewithindays)
												}
											/>
										) : filterData.filtertype == 1000 ? (
											<Thousand
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												onChange={updateDefaultValues}
											/>
										) : filterData.filtertype == 1001 ? (
											<Thousandone
												defaultpreviousdate={props.defaultpreviousdate}
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												onChange={updateDefaultValues}
											/>
										) : filterData.filtertype == 1002 ? (
											<Thousandtwo
												filterData={
													UpdateddefaultValue[0].values[filterData.filtername]
												}
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												onChange={updateDefaultValues}
												setsearchblankhandle={() => setsearchblankhandle}
											/>
										) : filterData.filtertype == 1003 ? (
											<Thousandthree
												filterData={
													UpdateddefaultValue[0].values[filterData.filtername]
												}
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												onChange={updateDefaultCheckboxValues}
												lastChange={lastChange}
												searchTerm={searchTerm}
											/>
										) : filterData.filtertype == 1004 ? (
											<Thousandfour
												filterData={
													UpdateddefaultValue[0].values[filterData.filtername]
												}
												defdata={
													UpdateddefaultValue[0].def[filterData.filtername]
												}
												onChange={updateDefaultValues}
											/>
										) : (
											""
										))}
								</div>
							</div>
						</div>
					</Modal.Body>

					<Modal.Footer
						style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
					>
						<div
							className="bbtndanger"
							style={{ color: "#fff", fontSize: "17px" }}
							onClick={clearFilters}
						>
							Clear Filters
						</div>
						<div
							className="bbtninfo"
							style={{ color: "#fff", fontSize: "17px" }}
							onClick={applyFilters}
						>
							Apply
						</div>
					</Modal.Footer>
				</Modal>
			)}
		</>
	);
};

export default Filters;
